import { render, staticRenderFns } from "./DragHotSpot.vue?vue&type=template&id=227f19fa"
import script from "./DragHotSpot.vue?vue&type=script&lang=js"
export * from "./DragHotSpot.vue?vue&type=script&lang=js"
import style0 from "./DragHotSpot.vue?vue&type=style&index=0&id=227f19fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports